import { User } from "src/app/core/models/user";
import { ChatMessage } from "./chat-message";

export class ChatDict {
    user: User;
    messages: ChatMessage[];
}
